import { QueryKey, UseQueryOptions } from 'react-query';
import { LimitedSchemaQueryOptions, SchemaQueryKey } from '@frontend/react-query-helpers';
import type { SchemaIO } from '@frontend/schema';
import { GetCallEditHistoryIO, ServiceStandardQueries } from '../types';
import { DemoData, useAdaptiveQuery } from './adaptive-queries/use-adaptive-query';

export interface useGetCallEditHistoryArgs<E = unknown, T = GetCallEditHistoryIO['output']> {
  demoData: DemoData<T>;
  demoQueryOptions?: Omit<UseQueryOptions<T, E, T>, 'queryKey' | 'queryFn'>;
  payload: GetCallEditHistoryIO['input'];
  isDemoAccount: boolean;
  realQueryOptions?: LimitedSchemaQueryOptions<
    SchemaIO<ServiceStandardQueries['GetCallEditHistory']>,
    E,
    T,
    SchemaQueryKey<ServiceStandardQueries, 'GetCallEditHistory'>
  >;
}

export function useGetCallEditHistory<E = unknown, T = GetCallEditHistoryIO['output']>({
  demoData,
  demoQueryOptions,
  payload,
  isDemoAccount,
  realQueryOptions,
}: useGetCallEditHistoryArgs<E, T>) {
  const { id, locationId } = payload;

  const isValidFilters = !!(id && locationId);

  return useAdaptiveQuery<'GetCallEditHistory', E, T>({
    buildDemoQueryKey: ({ endpointName, request }) => ['demo', endpointName, request] as QueryKey,
    demoData,
    demoQueryEnabled: isValidFilters,
    demoQueryOptions,
    isDemoAccount,
    realQueryArgs: {
      endpointName: 'GetCallEditHistory',
      request: payload,
      options: realQueryOptions,
    },
    realQueryEnabled: isValidFilters,
  });
}
